export default __webpack_public_path__ + "static/media/elegant.860d4084.png";